import { ROUTE_PATH } from "common/constants/sm-constants";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";

export class BranchesGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
        super(
            'Branch',
            ROUTE_PATH.branchGrid,
            ROUTE_PATH.addBranches,           
            true,
            true,
            8,
            false,
            true,
            ['department_name'],
            true,
            [],
            { isDownloadExcel: false, excelFileName: '', btnLabel: '', headers: [] },
            false,
            null,
            false,
            false,
            true,
            null,
            { evalKey: 'wantToDelete', evalParam: [0], decisiveParam: false }
           
            
        );
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
       
        const branchCatName = new Headers('Main Branch Category', 'branchCatName', false, true, 'text');
        const department_name = new Headers('Sub Branch', 'department_name', false, true, 'text');
       
        
        headers.push(branchCatName);
        headers.push(department_name);
      
       
        return headers;
    }
}